export const DRLP_MARKETO_FORMS = {
  CONTENT_REGISTRATION: "1021",
  PROGRESSIVE_PROFILING: "2601",
  VIEW_DEMOS_GATE: "2377",
  GOLDCAST_WEBINAR: "2803",
} as const;

const NATIVE_MARKETO_FORM_IDS: readonly string[] = [
  DRLP_MARKETO_FORMS.PROGRESSIVE_PROFILING,
  DRLP_MARKETO_FORMS.GOLDCAST_WEBINAR,
];

export function isNativeMarketoForm(marketoFormId: string | undefined) {
  return !!marketoFormId && NATIVE_MARKETO_FORM_IDS.includes(marketoFormId);
}
